const categories = [
  {
    category_id: 19,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: "Speaker's List",
    dir_name: 'speakers_list',
    user_id: null,
  },
  {
    category_id: 9,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'Provincial Bills',
    dir_name: 'provincial_bills',
    user_id: null,
  },
  {
    category_id: 32,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'Diaries',
    dir_name: 'diary',
    user_id: null,
  },
  {
    category_id: 41,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'Section 76 Bills',
    dir_name: 'section76_bills',
    user_id: null,
  },
  {
    category_id: 2,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'Annual Report',
    dir_name: 'annual_report',
    user_id: null,
  },
  {
    category_id: 3,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'Media Releases',
    dir_name: 'media_releases',
    user_id: null,
  },
  {
    category_id: 4,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'Rules of the House',
    dir_name: 'house_rules',
    user_id: null,
  },
  {
    category_id: 5,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'Provincial Acts',
    dir_name: 'provincial_acts',
    user_id: null,
  },
  {
    category_id: 6,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'National Acts',
    dir_name: 'national_acts',
    user_id: null,
  },
  {
    category_id: 7,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'Bills',
    dir_name: 'bills',
    user_id: null,
  },
  {
    category_id: 8,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'Petitions',
    dir_name: 'petitions',
    user_id: null,
  },

  {
    category_id: 11,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'Order Papers',
    dir_name: 'order_papers',
    user_id: null,
  },
  {
    category_id: 12,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'ATC',
    dir_name: 'atc',
    user_id: null,
  },
  {
    category_id: 13,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'Question Papers',
    dir_name: 'question_papers',
    user_id: null,
  },
  {
    category_id: 14,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'Minutes',
    dir_name: 'minutes',
    user_id: null,
  },
  {
    category_id: 15,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'Policy Speech',
    dir_name: 'policy_speech',
    user_id: null,
  },
  {
    category_id: 16,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'Public Speech',
    dir_name: 'public_speeches',
    user_id: null,
  },

  {
    category_id: 20,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'Strategic Plan',
    dir_name: 'strategic_plan',
    user_id: null,
  },
  {
    category_id: 21,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'Organogram',
    dir_name: 'organogram',
    user_id: null,
  },
  {
    category_id: 22,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'Committee Report',
    dir_name: 'committee_report',
    user_id: null,
  },
  {
    category_id: 23,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'Operational Plan',
    dir_name: 'operational_plan',
    user_id: null,
  },
  {
    category_id: 24,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'Annual Performance Plan',
    dir_name: 'annual_performance_plan',
    user_id: null,
  },
  {
    category_id: 25,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'State Of the Province Address',
    dir_name: 'sopa',
    user_id: null,
  },
  {
    category_id: 26,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'Technical Indicator',
    dir_name: 'technical_indicator',
    user_id: null,
  },
  {
    category_id: 27,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'Hansards',
    dir_name: 'hansards',
    user_id: null,
  },
  {
    category_id: 28,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'Constitutions',
    dir_name: 'constitution',
    user_id: null,
  },
  {
    category_id: 29,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'Photos',
    dir_name: 'gallery',
    user_id: null,
  },
  {
    category_id: 30,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'Legibrief',
    dir_name: 'legibrief',
    user_id: null,
  },
  {
    category_id: 31,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'House Documents',
    dir_name: 'house_documents',
    user_id: null,
  },

  {
    category_id: 33,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'End of Term Report',
    dir_name: 'end_of_term_report',
    user_id: null,
  },
  {
    category_id: 34,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'Oversight Visits',
    dir_name: 'consideration_oversight_visits',
    user_id: null,
  },
  {
    category_id: 38,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'Annual',
    dir_name: 'consideration_annuals',
    user_id: null,
  },
  {
    category_id: 39,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'Financial Oversight',
    dir_name: 'consideration_financial_oversight',
    user_id: null,
  },
  {
    category_id: 40,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'Half Year Report',
    dir_name: 'half_year_report',
    user_id: null,
  },
  {
    category_id: 43,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'Tabled Documents',
    dir_name: 'tabled_documents',
    user_id: null,
  },
  {
    category_id: 42,
    created_at: null,
    updated_at: null,
    deleted_at: null,
    name: 'Oversight',
    dir_name: 'oversight',
    user_id: null,
  },
];

export default categories;
